import React from "react"

import BssoPermissions from "components/LM/Bsso/Permissions";
import VoiceRecovery from "components/LM/Voice/Recovery";

function RecoveryPage(props) {
	return (
		<BssoPermissions permissions={["social_recovery", "voices"]} behaviour="error">
			<VoiceRecovery {...props}/>
		</BssoPermissions>
	)
}

export default RecoveryPage;
